module.exports = __webpack_public_path__ + "img/PlaceholderLogo.be21134b.svg";